// extracted by css-extract-rspack-plugin
export default {"avatar":"Issues-module__avatar__W7zyE"};